/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";
import { useTranslation } from "next-i18next";

import CheckmarkFilledIcon from "../../resources/checkmark-filled.svg";

import styles from "./PaymentStatus.module.scss";

export const UpdatePaymentStatusSuccess = () => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.status}>
      <CheckmarkFilledIcon className={styles.icon} />
      <p className={styles.info}>{t("web_payment_update_success")}</p>
    </div>
  );
};
